import * as requestFromServer from "./adminDashboardApi";
import { adminDashboardSlice, callTypes } from "./adminDashboardSlice";

const { actions } = adminDashboardSlice;

export const fetchAccountsStatistics = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getAccountsStatistics()
    .then((response) => {
      if (response && response.data) {
        dispatch(actions.setAccountsStatistics(response.data));
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find accounts";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchUnmappedFiles = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getUnmappedFiles(queryParams)
    .then((response) => {
      if (response && response.data) {
        const totalCount = response.data.totalCount;
        const entities = response.data.logs;

        dispatch(actions.setUnMappedFilesFetched({ totalCount, entities }));
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find accounts";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchUnknownEmailSender = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getUnknownEmailSender(queryParams)
    .then((response) => {
      if (response && response.data) {
        const totalCount = response.data.totalCount;
        const entities = response.data.logs;

        dispatch(
          actions.SetUnknownEmailSendersFetched({ totalCount, entities })
        );
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find accounts";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
